import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { config } from "@/config/env";
import { getCurrentJWT } from "utils/tokens/tokenHelpers";

export const leaguesV2Api = createApi({
  reducerPath: "leaguesV2Api",
  baseQuery: fetchBaseQuery({
    baseUrl: config.apiBaseUrl,
    prepareHeaders: (headers) => {
      const token = getCurrentJWT();
      if (token) {
        headers.set("authorization", `Bearer ${token}`);
      }
      headers.set("Ocp-Apim-Subscription-Key", config.apimKey);
      headers.set("x-api-version", "2.0");
      return headers;
    },
  }),
  tagTypes: [
    "Dashboard",
    "AdjudicationQueue",
    "League",
    "LeagueRound",
    "LeagueRoster",
    "LeagueTeam",
    "LeagueGroup",
    "Standings",
    "RoundResults",
    "ScoringDetails",
    "HandicapHistory",
    "ScorecardReview",
  ],
  endpoints: () => ({}),
});
